<template>
 
  <Loader v-if="loading" />
  <Card>
    <template v-slot:title>
      <h3>Richieste Atleti </h3>
    </template>
    <template v-slot:content>
    <div class="col-12">
  <!-- Bottone per aggiungere/chiudere le box -->
  <Button 
    @click="addBox" 
    class="p-button-info mb-3" 
    :label="boxes.length === 0 ? 'Nuova' : 'Chiudi'" 
  />

  <!-- Loop sulle box -->
  <div 
    v-for="(box, index) in boxes" 
    :key="index" 
    class="box p-4 mb-4 border-round border-1 surface-border shadow-1"
  >
    <div class="p-fluid grid">
      <!-- Dropdown Atleta -->
      <div class="field col-12 md:col-3">
        <label for="id_atleta">Atleta</label>
        <Dropdown 
          id="id_atleta" 
          v-model="box.atleta" 
          :options="atleti" 
          :filter="true" 
          placeholder="Seleziona un atleta" 
          :class="{'p-invalid': validationErrors.atleta && submitted}" 
          :virtualScrollerOptions="{ itemSize: 38 }" 
          @change="onChangeInput($event, 'atleta')"
        >
          <template #value="slotProps">
            <div v-if="slotProps.value">
              {{ slotProps.value.nome }} {{ slotProps.value.cognome }}
            </div>
            <span v-else>{{ slotProps.placeholder }}</span>
          </template>
          <template #option="slotProps">
            <div>
              {{ slotProps.option.nome }} {{ slotProps.option.cognome }} {{ slotProps.option.nota }}
            </div>
          </template>
        </Dropdown>
      </div>

      <!-- Dropdown Corso -->
      <div class="field col-12 md:col-3">
        <label for="id_corso">Corso</label>
        <Dropdown 
          id="id_corso" 
          v-model="box.tipocorso" 
          :options="corsi" 
          :filter="true" 
          placeholder="Seleziona corso" 
          :class="{'p-invalid': validationErrors.corso && submitted}" 
          :virtualScrollerOptions="{ itemSize: 38 }" 
          @change="onChangeInput($event, 'corso')"
        >
          <template #value="slotProps">
            <div v-if="slotProps.value">{{ slotProps.value.nome }}</div>
            <span v-else>{{ slotProps.placeholder }}</span>
          </template>
          <template #option="slotProps">
            <div>{{ slotProps.option.nome }} {{ slotProps.option.nota }}</div>
          </template>
        </Dropdown>
      </div>

      <!-- Textarea Nota -->
      <div class="field col-12 md:col-6">
        <label for="nota">Nota</label>
        <Textarea 
          id="nota" 
          v-model="box.nota" 
          placeholder="Inserisci una nota" 
          rows="4" 
          autoResize
        />
      </div>
    </div>

    <!-- Bottone Salva -->
    <div class="mt-3 text-right">
      <Button 
        class="p-button-success" 
        icon="pi pi-check" 
        @click="saveBox(index)" 
        label="Salva"
      />
    </div>
  </div>
</div>

     <div class="col-12 flex flex-column md:col-12">
  <DataTable :value="richiesteUtenti" tableStyle="min-width: 50rem">
    
    <!-- Data creazione -->
    <Column field="creation_time" header="Data creazione">
      <template #body="slotProps">
        {{ moment(slotProps.data.creation_time).format('DD/MM/Y') }}
      </template>
    </Column>

    <!-- Nota -->
    <Column field="nota" header="Nota"></Column>

   

    <!-- Atleti -->
    <Column header="Atleti">
      <template #body="{ data }">
        <div v-for="atleta in data.atleti" :key="atleta.id">
          <Button 
            @click="goToAtleta(atleta.id)"  
            class="p-button-link">
            {{ capitalize(atleta.nome) }} {{ capitalize(atleta.cognome) }}
          </Button>
          <!-- Corsi dell'atleta -->
          <div v-if="atleta.corsi && atleta.corsi.length > 0" class="ml-2 text-sm ">
            <span v-for="(corso, index) in atleta.corsi" :key="corso.id">
              {{ corso.nome }}<span v-if="index < atleta.corsi.length - 1">, </span>
            </span>
          </div>
        </div>
      </template>
    </Column>

    <!-- Data di nascita (dal primo atleta) -->
    <Column header="Data di Nascita">
      <template #body="{ data }">
        <span v-if="data.atleti.length > 0">
          {{ moment(data.atleti[0].datadinascita).format('DD/MM/YYYY') }}
        </span>
      </template>
    </Column>

    <!-- Gestito -->
    <Column header="Gestito" field="gestito">
      <template #body="slotProps">
        <Button 
          @click="gestisciRichiesta(slotProps.data.id, slotProps.data.gestito, slotProps.data.corso)" 
          :label="slotProps.data.gestito == 0 ? 'NO' : 'SI'" 
          :class="slotProps.data.gestito == 0 ? 'p-button-warning' : 'p-button-success'" 
        />
      </template>
    </Column>

    <!-- Data gestione -->
    <Column field="data_gestone" header="Data gestione">
      <template #body="slotProps">
        <span v-if="slotProps.data.data_gestone">
          {{ moment(slotProps.data.data_gestone).format('DD/MM/Y HH:mm') }}
        </span>
      </template>
      </Column>

  </DataTable>
</div>

    </template>
  </Card>
</template>

<script>
import {ref, onMounted, getCurrentInstance } from 'vue';
import Loader from "@/components/Loader.vue";
import Service from '@/services/levante-api/levante-api';
import { useToast } from 'primevue/usetoast';
import moment from 'moment'
import Textarea from 'primevue/textarea';

export default {
  components: {
    Loader,
  },
  setup() {
    const loading = ref(true);
    const richiesteUtenti = ref([]);
    const self = getCurrentInstance();
    const toast = useToast();
    const corsi = ref([])
    
    const atleti = ref([])
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const boxes = ref([])
    const lifeTime = 3000;

    const validationErrors = ref({})
    const confirmDialog = ref({
      visible: false,
      id: null,
      visibile: null,
      selectedCorso: null
    });
 const goToAtleta = (idatleta)=> {
            window.open(`/atleta/${idatleta}/dettagli`)
        }

    const capitalize = (str) => {
      if (!str) return '';
      return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    };
   
    const gestisciRichiesta = async (id,approvato,selectedCorso) => {
      approvato = approvato === 0 ? 1 : 0;
      loading.value = true;

      try {
        let fd = new FormData();  
        fd.append('gestito',approvato);
        
        await service.updateApprovaRichiestaApp(id,fd);  // assuming this endpoint exists
        toast.add({ severity: 'success', summary: 'Successo', detail: 'Richiesta aggiornata con successo',life: lifeTime});
        initData();
      } catch (error) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'aggiornamento della richiesta',life: lifeTime });
      } finally {
        loading.value = false;
      }
    };
    const onChangeInput = (evt, prop) => {
      let value
      switch (prop) {
        case 'corso':
        value = evt.value
        
        getAtleti()
        getCorsiAttivi()
        break;
        case 'atleta':
        value = evt.value
        
        getAtleti()
        getCorsiAttivi()
        break;
        default:
        value = evt.target.value
        break;
      }
      if (value == '' || value == null) {
        validationErrors.value[prop] = true
      }else{
        delete validationErrors.value[prop]
      }
    }



    const getCorsiAttivi = async () => {
      await service.getCorsiAttivi()
      .then((res) => {
        corsi.value = res.items
      })
    }
    const getAtleti = async () => {
      await service.getAtleti()
      .then((res) => {
        atleti.value = res.items
      })
    }
    const initData = () => {
      // restart var

      service.getRichiesteUtenti().then((res) => {
        richiesteUtenti.value = res.items.notes
        console.log(richiesteUtenti.value);
        loading.value = false;
      });

      corsi.value = []
      getCorsiAttivi()
      atleti.value = []
      getAtleti()
      
    }
 
    const addBox = () => {
      if (boxes.value.length==0)
        boxes.value.push({
          title: '',
          corso: null,
          tipocorso:null,
          image: null,
          atleta:null
        });
      else{
        boxes.value.pop();
      }
    }
    const validateForm = () => {
      return true;
    }
    const saveBox = async (index) => {
      if(validateForm()){
        loading.value = true
        const box = boxes.value[index];
        let fd = new FormData();  
        console.log(box.corso);
        fd.append('tipocorso', box.tipocorso.id);
        fd.append('atleta', box.atleta.id);
        
        service.sendRichiestaProva(fd)
        .then((res) => {
          let severity = res.item.esito
          let summary = res.item.esito != 'success' ? 'Attenzione' : 'Successo'
          let detail = res.item.messaggio
          //if(res.item.esito != 'success'){
            initData()
          //}
          if (res.item.esito=='success'){
            boxes.value.pop();
          }
          toast.add({severity:severity, summary: summary, detail:detail,life: lifeTime});
        }).finally(() => {
          loading.value = false
        })
      }else{
        toast.add({severity:'warn', summary: 'Attenzione', detail:`Ci sono dei dati mancanti`,life: lifeTime});
      }
    }
   
    onMounted(() => { 
      loading.value = true
      const promises = [initData()]
      
      Promise.all(promises)
      .then(()=>{
          
      }).finally(()=>{
          loading.value = false
      })
    })

    return {
      loading,
      richiesteUtenti,
      addBox,
      saveBox,
      capitalize,
      gestisciRichiesta,
      boxes,
      corsi,
      atleti,
      validationErrors,
      onChangeInput,
      moment,confirmDialog,
      goToAtleta
    };
  },
}
</script>

<style scoped>
.confirm-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  z-index: 1000;
}

.confirm-dialog-content {
  text-align: center;
}

.confirm-dialog-content h3 {
  margin-top: 0;
}

.confirm-dialog-content button {
  margin: 10px;
}
</style>
